/**
 * Formats a given date string or Date object into "DD MON YYYY" (e.g., "13 NOV 2025").
 * 
 * @param {string | Date} dateInput - The input date (ISO string or Date object).
 * @returns {string} - Formatted date string like "13 NOV 2025".
 */
export function formatDate(dateInput) {
  if (!dateInput) return "";

  try {
    const date = new Date(dateInput);
    if (isNaN(date)) return "";

    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .toUpperCase();
  } catch (err) {
    console.error("Date formatting error:", err);
    return "";
  }
}
